import styled from "styled-components";
import BlurMap from "../../../assets/blur-map.jpg";

export const Container = styled.div`

  .MuiAccordion-root {
    box-shadow: none;

    /* An alert already handled stays listed, but set apart from the pending ones */
    &.is-justified {
      .alert-type-icon {
        filter: grayscale(1);
        opacity: 0.55;
      }

      .type {
        color: #616161 !important;
      }
    }

    .boxHeaderItemsEvent {
      padding: 0;

      .MuiAccordionSummary-content {
        align-items: center;
        display: block;
        margin-bottom: 0;

        .content {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 4px 0 8px 0;

          .boxHeaderItemsIcon {
            position: relative;
            flex: none;

            .alert-type-icon {
              display: block;
            }

            svg {
              width: 30px;
              height: 30px;
            }

            /* Check of a handled alert, on the corner of its icon */
            .justified-badge {
              position: absolute;
              right: -7px;
              bottom: -5px;
              display: grid;
              place-items: center;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: #FFFFFF;
              cursor: help;

              svg.MuiSvgIcon-root {
                width: 20px;
                height: 20px;
                color: #2E7D32;
              }
            }
          }

          .boxHeaderItemsDescription {
            width: 100%;
            padding-left: 15px;
            display: flex;
            flex-direction: column;

            .heading {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .type {
                padding-right: 10px;
                width: 8rem;
              }
            }

            .typeAndDuration {
              font-weight: 600;
              font-size: 1rem;

              .duration {
                display: flex;
                width: 100px;
                justify-content: flex-end;
              }
            }

            .occurrenceDate, .startDate, .finishDate, .speed, .fuel, .temperature {
              font-size: 0.8rem;
              color: black;

              .colorRed {
                color: red;

                // PlayArrowIcon
                svg {
                  color: black;
                }
              }
              }
            }

            .startDate {
              color: rgb(0 0 0 / 60%);
            }
          }
        }
      }
    }

    .boxContentItemsEvent {
      padding: 8px 16px 0 16px;
      display: block;

      .maps {
        margin-bottom: 0 !important;

        .hidden {
          display: none !important;
        }

        .staticMap {
          height: 250px !important;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: url(${BlurMap});
          background-repeat: no-repeat;
          background-size: cover;

          img {
            cursor: pointer;
            width: 40px;
            border-radius: 50%;
            font-weight: bold;
            background-color: white;
            /* box-shadow: 10px 10px 5px 0px rgb(0 0 0 / 75%); */
          }
        }

        .drawerMap {
          height: 250px !important;
        }
      }

      .actions {
        margin: 5px 0;
        text-align: end;
      }
    }
    .MuiSvgIcon-root {
      width: 0.4em;
      height: 0.4em;
  }
`;
